/**
 * Which tab a piece of work belongs to, in ONE place.
 *
 * The assigned-work endpoint decides this server-side and sends `isHomework`,
 * which is authoritative. Published RESULTS come from a different endpoint that
 * has no such flag - only the category's name - so this also recognises the
 * name, and both screens ask the same question of both payloads.
 */

/** "Home Work", "Homework", "HOMEWORK - Term 2" all count. */
export function isHomeworkCategory(name?: string | null): boolean {
  if (!name) return false;
  // Squashed to letters only: the school types the category name, so spacing
  // and punctuation are theirs to choose, not ours to depend on.
  return name.replace(/[^a-zA-Z]/g, '').toLowerCase().includes('homework');
}

/**
 * Whether a row belongs under Homework rather than Assessments.
 *
 * Prefers the server's own flag and falls back to the category name, so a
 * payload carrying only one of the two still lands in the right tab.
 */
export function belongsToHomeworkTab(row: any): boolean {
  const flag = row?.isHomework ?? row?.IsHomework;
  if (typeof flag === 'boolean') return flag;
  return isHomeworkCategory(row?.categoryName ?? row?.CategoryName);
}
